import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface Notification {
  message: string;
  type: 'error' | 'success' | 'info';
  timeout?: number;
}

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private notificationSubject = new BehaviorSubject<Notification | null>(null);

  public notification$: Observable<Notification | null> = this.notificationSubject.asObservable();

  showError(message: string, timeout = 5000): void {
    this.notificationSubject.next({ message, type: 'error', timeout });

    if (timeout > 0) {
      setTimeout(() => {
        this.clear();
      }, timeout);
    }
  }

  showSuccess(message: string, timeout = 5000): void {
    this.notificationSubject.next({ message, type: 'success', timeout });

    if (timeout > 0) {
      setTimeout(() => {
        this.clear();
      }, timeout);
    }
  }

  showInfo(message: string, timeout = 10000): void {
    this.notificationSubject.next({ message, type: 'info', timeout });

    if (timeout > 0) {
      setTimeout(() => {
        this.clear();
      }, timeout);
    }
  }

  clear(): void {
    this.notificationSubject.next(null);
  }
}
